import { observable, makeAutoObservable } from 'mobx';
import { PromoCodesState } from 'src/AppState/PromoCodesState/PromoCodesState';

export class PromoCodeFormState {
    constructor(private readonly promoCodeState: PromoCodesState) {
        makeAutoObservable(this);
    }
    @observable public startDateError = false;
    @observable public endDateError = false;
    @observable public isUnlimited = false;

    public onChangeStartDate = (date: Date | null): void => {
        if (date !== null) {
            this.promoCodeState.date_from.setValue(date.toISOString());
        }
    };

    public onBlurStartDate = (date: React.FocusEvent<HTMLInputElement>): void => {
        if (date.target.value === '') {
            this.startDateError = true;
        } else if (this.startDateError) {
            this.startDateError = false;
        }
    };

    public onChangeEndDate = (date: Date | null): void => {
        if (date !== null) {
            this.promoCodeState.date_to.setValue(date.toISOString());
        }
    };

    public onChangeUnlimited = () => {
        this.isUnlimited = !this.isUnlimited;
        this.promoCodeState.isUnlimited = this.isUnlimited;
    };

    public onBlurEndDate = (date: React.FocusEvent<HTMLInputElement>): void => {
        if (date.target.value === '') {
            this.endDateError = true;
        } else if (this.endDateError) {
            this.endDateError = false;
        }
    };

    public preventDefault = (e: React.FormEvent<HTMLFormElement>): void => {
        e.preventDefault();
    };
}
